import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MCardHeaderTabComponent } from './card-header-tab.component';

@NgModule({
  declarations: [MCardHeaderTabComponent],
  exports: [MCardHeaderTabComponent],
  imports: [CommonModule, NzIconModule]
})
export class MCardHeaderTabModule {}
